export default __webpack_public_path__ + "static/media/warning--divided-highway-to-left--g1.789096ef.png";